import ReactDOM from 'react-dom'
import * as React from 'react'
import '../src'

globalThis.React = React

import App from './App'

if (document.getElementById('root')) {
	ReactDOM.render(<App />, document.getElementById('root'))
}
